/**
 * Loads a JavaScript script by writing out a script tag, but checks
 * that it hasn't already loaded it before doing so. You can also create
 * a Foundation.Script with the optional async parameter set to true and
 * the script will be loaded without holing up the rendering of the page.
 * In both cases, you can attach callbacks via the then() method. Note
 * that attaching callbacks via "otherwise" are not guaranteed to be
 * called in every browser even in the case of a 404, so don't rely on
 * this. 
 * @constructor
 * @extends {Foundation.Promise}
 * @param {string} url
 * @param {(boolean|string)=} async
 */
Foundation.Script = function (url, async) {
    Foundation.Promise.call(this);

    /**
     * @private
     * @type {string}
     */
    this._url = url;
    
    if (Foundation.Script.seen[url]) {
        this.marry(Foundation.Script.seen[url]);
    }
    else {
        Foundation.Script.seen[url] = this;
        
        if (!async) {
            document.write(`<script src='${url}'></script>`);
            this.marry(Foundation.Timer.deferral());
        }
        else {
            var script = jQuery("<script></script>");
            script.attr("src", url);
            script.attr("async", "async");

            if (script[0].onreadystatechange !== undefined) {
                // For IE.
                script.on("readystatechange", function () {
                    var readyState = script[0]["readyState"];
                    if (readyState === "loaded" || readyState === "complete") {
                        this.tryFulfill();
                    }
                }.bind(this));
            }
            else {
                script.on("load", this.tryFulfill.bind(this));
                script.on("error", this.tryFail.bind(this));
            }
            
            var someOtherScriptTag = document.getElementsByTagName("script")[0];
            someOtherScriptTag.parentNode.insertBefore(script[0], someOtherScriptTag);
            
            if (Foundation.isString(async)) {
                window[async] = this.tryFulfill.bind(this);
            }
        }
    }
};
Foundation.inherit(Foundation.Script, Foundation.Promise);

/**
 * Set the script tag element's ID attribute.
 * @param {string} theId
 */
Foundation.Script.prototype.setElementId = function (theId) {
    jQuery(`script[src='${this._url}']`)[0].id = theId;
};


/**
 * @private
 * @type {Object.<string,Foundation.Promise>}
 */
Foundation.Script.seen = {};

// ---------------------------------------------------------------------

window["Foundation"]["Script"] = Foundation.Script;

// Legacy compatibility.
window["dnLoadScript"] = function (a, b) { new Foundation.Script(a, b); };
